// import React from 'react';
import React, { useEffect, useState } from "react";
import axios from 'axios';
import {
    Link
  } from 'react-router-dom';
  import { Grid } from 'antd-mobile';
  import AppHeader from './AppHeader';



const styles = {
    // bgColor: 'white',
    titleTextColor: "#00008B",
    rowTitleColor: "#00008B",
    // rowContentColor: 'grey',
    // arrowColor: "red",
};

const config = {
    animate: true,
    arrowIcon: "V",
    tabFocus: true
};

let NUM_ROWS = 10;

let URL = "http://thahtaylay.com/";

class DownloadPage extends React.Component {
    constructor(props) {
            super(props)
            window.BPdata.footerMenu = "HelpCenter";

            this.state = {
                banners: [],
                select_banners: [],
                step: "login",
                message : "",
                title: "",
                promotion_id : 0,

            };

        }

    hisUrl(url) {
        if(localStorage.getItem("route")) {
          let menu = JSON.parse(localStorage.getItem("route"));
          //console.log(menu.length+"-------------")
          if(menu.length === "0") {
            let data = ["/"];
            localStorage.setItem("route", JSON.stringify(data) );
          } else {
            if(menu[menu.length - 1] !== url ){
              menu.push(url)
              localStorage.setItem("route", JSON.stringify(menu) );
            }
          }

          // localStorage.setItem("route", JSON.stringify(menu) );
          // console.log(localStorage.getItem('route'));
        }
       // console.log(localStorage.getItem('route'));
    }


    componentDidMount() {

        if(localStorage.getItem('banners')) {

          if(JSON.parse(localStorage.getItem("banners")) != null) {
            let video_slides = JSON.parse(localStorage.getItem("banners"));
            this.setState({banners: video_slides})
          }
        }


        window.scrollTo(0, 0);


    }



    render() {
        return (
            <div className="page">
                {/* <AppHeader backLink="" titleType="1" title={window.lang.more.share_app} isLoading="false" /> */}
                <div className="page-content">

                    <div className="main-content ">
                        <div className="row">

                            <div className="grid-100 text-center">
                                

                            <br />
                            <br />
                            <span>APP ‌ဖုန်းထဲထည့်သွင်းပြီးပါက <br /> Browser မှဝင်စရာမလိုပဲ တိုက်ရိုက်အသုံးပြုနိုင်သည်။</span>
                            <br />
                            <br />
                            <img src="/img/logo.png" className="medium-logo" />
                            <br />
                            <Link to="/download/ios" className="btn btn-success grid-50">IOS Install လုပ်ရန်နှိပ်ပါ</Link><br /><br />

                            <Link to="/download/android" className="btn btn-yellow_guide grid-50 color-black">Android App Install လုပ်ရန်နှိပ်ပါ</Link><br /><br />

                            </div>
                        </div>
                      <br />

                    <br />
                    </div>
                </div>

                <footer  className="App-footer">

                    <div className="App-footer-inner">
                      {/* {window.BPdata.footerMenu} */}
                      <Grid data={window.lang.footer}
                          columnNum={5}
                          renderItem={dataItem => (

                            <Link to={dataItem.url} className="cont-wrap-link hvr-pulse-shrink" style={{width: '100%'}}>
                                  { (window.BPdata.footerMenu === dataItem.check )  ? (dataItem.text == "My Profile") ?  <span className="color-white"><img src={dataItem.icon}  height="25px"/><br />{(this.checklogin()) ? dataItem.text : "Login / Register" }</span> : <span className="text-white"><img src={dataItem.icon_off}  height="25px"/><br /><span >{dataItem.text}</span> </span> : <span className="text-white"><img src={dataItem.icon}  height="25px"/><br />{dataItem.text} </span> }

                            </Link>
                          )}
                        />

                    </div>
                  </footer>
            </div>
        );
    }
}

export default DownloadPage;

